import { Link } from "react-router-dom";
import { ArrowLeft, Home } from "lucide-react";
import "./NotFound.css";
import SEO from "../components/SEO";

export default function NotFound() {
  return (
    <section className="notfound">
        <SEO
        title="404 – Page introuvable | Daniela Parito Architecture"
        description="La page demandée est introuvable. Découvrez les projets et réalisations de Daniela Parito Architecture."
        noindex
        />
      <div className="notfound-container">
        <span className="notfound-code">404</span>

        <h1 className="notfound-title">
          Page introuvable
        </h1>

        <p className="notfound-text">
          Cette page n’existe pas ou a été déplacée.<br />
          L’architecture commence toujours par une bonne orientation.
        </p>

        <div className="notfound-actions">
          <Link to="/" className="notfound-btn primary">
            <Home size={18} />
            Retour à l’accueil
          </Link>

          <Link to="/projects" className="notfound-btn secondary">
            <ArrowLeft size={18} />
            Voir les projets
          </Link>
        </div>
      </div>
    </section>
  );
}
